import React from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";
import { formatLeadTime, buildLeadTimeTooltip } from "./formatLeadTime";

export const StockChip = React.memo(function StockChip({
  showStock,
  variantStock,
  activeSku,
}) {
  if (!showStock) return null;
  const { stock, leadtime, fetching, type } = variantStock;
  if (!activeSku)
    return (
      <Chip
        size="small"
        variant="outlined"
        label="Stock: "
        sx={{ opacity: 0.6 }}
      />
    );
  if (fetching && stock == null)
    return (
      <Skeleton
        variant="rounded"
        width={82}
        height={24}
        sx={{ borderRadius: 16 }}
        aria-label="Loading stock"
      />
    );
  if (stock == null)
    return (
      <Chip
        size="small"
        variant="outlined"
        label="Stock: "
        sx={{ opacity: 0.6 }}
      />
    );
  const numeric = Number(stock);
  if (Number.isNaN(numeric))
    return (
      <Chip
        size="small"
        variant="outlined"
        label="Stock: "
        sx={{ opacity: 0.6 }}
      />
    );
  if (numeric === 0) {
    if (leadtime) {
      const formatted = formatLeadTime(leadtime);
      return (
        <Tooltip title={buildLeadTimeTooltip(type, leadtime)}>
          <span>
            <Chip
              size="small"
              color="warning"
              variant="outlined"
              label={`Lead time: ${formatted}`}
              aria-label={`Lead time ${formatted}`}
            />
          </span>
        </Tooltip>
      );
    }
    return (
      <Chip
        size="small"
        color="error"
        label={`Lead time: Unknown`}
        aria-label={`Lead time Unknown`}
      />
    );
  }
  return (
    <Chip
      size="small"
      color="info"
      label={`Stock: ${numeric}`}
      aria-label={`Stock ${numeric}`}
      sx={{ fontVariantNumeric: "tabular-nums" }}
    />
  );
});

export default StockChip;
